import {ApiEndpointUrl} from "../../common";
export const menuPoint = { list: ApiEndpointUrl + "menulist" };
